import { render, staticRenderFns } from "./FailedEmails.vue?vue&type=template&id=47b9c85b&scoped=true"
import script from "./FailedEmails.vue?vue&type=script&lang=js"
export * from "./FailedEmails.vue?vue&type=script&lang=js"
import style0 from "./FailedEmails.vue?vue&type=style&index=0&id=47b9c85b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b9c85b",
  null
  
)

export default component.exports